import pdfMake from 'pdfmake/build/pdfmake';
import { Content, TDocumentDefinitions } from 'pdfmake/interfaces';
import QRCode from 'qrcode';
import { encryptObject } from './encrypt';
import logo from '../assets/pdfLogoBlue.png';
import { convertImageToBase64 } from './generatePDF';

const buildTrailerQrPayload = (trailer: any) => ({
    type: 'trailer',
    v: 1,
    id: trailer.id,
    trailer_no: trailer.trailer_no,
});

const generateQrCode = async (trailer: any) => {
    const payload = buildTrailerQrPayload(trailer);
    const encrypted = encryptObject(payload);

    return await QRCode.toDataURL(encrypted, {
        errorCorrectionLevel: 'H',
        margin: 1,
        width: 900,
        color: {
            dark: '#000000',
            light: '#FFFFFF',
        },
    });
};

export const createQrPdf = async (trailer: any) => {
    const imageDataUrl = await convertImageToBase64(logo);
    try {
        const qrImage = await generateQrCode(trailer);

        const content: any[] = [
            // Logo placeholder area
            {
                table: {
                    widths: ['*'],
                    body: [
                        [
                            {
                                image: imageDataUrl,
                                border: [false, false, false, true],
                                margin: [0, 18, 0, 18],
                                fit: [150, 200], // Add this property to specify the image size
                                alignment: 'center',
                            },
                        ],
                    ],
                },
                layout: {
                    hLineColor: () => '#d6dbe3',
                    vLineWidth: () => 0,
                    hLineWidth: (i: number) => (i === 1 ? 1 : 0),
                },
                margin: [0, 0, 0, 16],
            },

            // Header
            {
                text: 'SVP LOGISTICS',
                alignment: 'center',
                fontSize: 21,
                bold: true,
                color: '#183153',
                margin: [0, 0, 0, 4],
            },
            {
                text: 'TRAILER QR TAG',
                alignment: 'center',
                fontSize: 11,
                color: '#6b7280',
                margin: [0, 0, 0, 22],
            },

            // QR container
            {
                table: {
                    widths: ['*'],
                    body: [
                        [
                            {
                                stack: [
                                    {
                                        image: qrImage,
                                        width: 330,
                                        height: 330,
                                        alignment: 'center',
                                        margin: [0, 8, 0, 18],
                                    },
                                    {
                                        text: String(trailer.trailer_no || ''),
                                        alignment: 'center',
                                        fontSize: 28,
                                        bold: true,
                                        color: '#111827',
                                        margin: [0, 0, 0, 4],
                                    },
                                    {
                                        text: 'SCAN FOR TRAILER DETAILS',
                                        alignment: 'center',
                                        fontSize: 10,
                                        color: '#6b7280',
                                    },
                                ],
                                margin: [18, 18, 18, 18],
                                border: [true, true, true, true],
                            },
                        ],
                    ],
                },
                layout: {
                    hLineColor: () => '#cfd6df',
                    vLineColor: () => '#cfd6df',
                    hLineWidth: () => 1,
                    vLineWidth: () => 1,
                },
                margin: [18, 0, 18, 0],
            },
        ];

        const docDefinition: TDocumentDefinitions = {
            pageSize: 'LETTER',
            pageOrientation: 'portrait',
            pageMargins: [28, 28, 28, 28],
            content,
            background: () => ({
                canvas: [
                    {
                        type: 'rect',
                        x: 12,
                        y: 12,
                        w: 588,
                        h: 768,
                        lineColor: '#d9dee7',
                        lineWidth: 1,
                    },
                ],
            }),
            defaultStyle: {
                fontSize: 10,
            },
        };

        pdfMake.createPdf(docDefinition).open();
    } catch (error) {
        console.log('Error Creating PDF:', error);
    }
};